import locale from 'uiv/src/locale/lang/es-ES';

const locales = {
  ...locale.uiv,
  multiSelect: {
    placeholder: 'Seleccione un item',
    filterPlaceholder: 'Busque un item',
  },
  datePicker: {
    ...locale.uiv.datePicker,
    week1: 'Lun',
    week2: 'Mar',
    week3: 'Mie',
    week4: 'Jue',
    week5: 'Vie',
    week6: 'Sab',
    week7: 'Dom',
  },
  modal: {
    ok: 'Sí',
    cancel: 'No, cancelar',
  },
};

export default {
  uiv: {
    ...locales,
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/uiv.js